interface IEnv {
    NODE_ENV: string;
    REACT_APP_API_URL: string;
    REACT_APP_SAMBA_PH: string;
    REACT_APP_PLATFORM_URL: string;
    REACT_APP_COOKIE_NAME: string;
    REACT_APP_COOKIE_DOMAIN: string;
    REACT_APP_GAME_API: string;
    REACT_APP_DAILY_QUESTIONS_API: string;
    REACT_APP_KIRA_WIDGET_URL: string;
    REACT_APP_KIRA_LEVEL_ID: string | undefined;
    REACT_APP_MEMORY_API: string;
    REACT_APP_PRINT_API: string;
    /** Destino do CTA da campanha #mostraseuaprova: a landing page da inscrição. */
    REACT_APP_MSA_CTA_URL: string;
}

const getEnv = (key: keyof IEnv): string => {
  const value = process.env[key];
  if (value === undefined) {
    // console.log(`Environment variable ${key} is not defined`);
  }
  return value ?? '';
};

const env: IEnv = {
  NODE_ENV: getEnv('NODE_ENV'),
  REACT_APP_API_URL: getEnv('REACT_APP_API_URL'),
  REACT_APP_SAMBA_PH: getEnv('REACT_APP_SAMBA_PH'),
  REACT_APP_PLATFORM_URL: getEnv('REACT_APP_PLATFORM_URL'),
  REACT_APP_COOKIE_NAME: getEnv('REACT_APP_COOKIE_NAME'),
  // Fallback para o domínio de produção quando a variável não vier do build:
  // sem ele o cookie iria para o host exato e deixaria de ser compartilhado
  // entre os subdomínios. Em dev o .env aponta para localhost, o que faz o
  // cookie realmente ser gravado (antes, fixo em produção, nunca era).
  REACT_APP_COOKIE_DOMAIN:
    getEnv('REACT_APP_COOKIE_DOMAIN') || '.aprovatotal.com.br',
  REACT_APP_GAME_API:
    getEnv('REACT_APP_GAME_API') ||
    'https://api-gamefication.aprovatotal.com.br/api',
  REACT_APP_KIRA_WIDGET_URL: getEnv('REACT_APP_KIRA_WIDGET_URL') || 'https://platform-storage-prod.s3.us-east-1.amazonaws.com/kira-aprova-total/dev-kira-widget.umd.cjs',
  REACT_APP_KIRA_LEVEL_ID: getEnv('REACT_APP_KIRA_LEVEL_ID') || "5b2186ec9c5aa43084ff7d07",
  REACT_APP_DAILY_QUESTIONS_API: getEnv('REACT_APP_DAILY_QUESTIONS_API') || "https://dev-api-gamefication.aprovatotal.com.br",
  REACT_APP_MEMORY_API:
    getEnv('REACT_APP_MEMORY_API') ||
    'https://dev-api-memory.aprovatotal.com.br/api', //getEnv('REACT_APP_COOKIE_DOMAIN')
  REACT_APP_MSA_CTA_URL:
    getEnv('REACT_APP_MSA_CTA_URL') ||
    'https://aprovatotal.com.br/lp/mostra-seu-aprova/',
  REACT_APP_PRINT_API: getEnv('REACT_APP_PRINT_API') || 'https://dev-api-print.aprovatotal.com.br/api',
};

export default env;
